// JavaScript 封装组件

class ScrollPanel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 判断是否是移动端（你可以根据需要改用 userAgent）
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // 移动端不执行
      return;
    }

    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const module = this.querySelector(".air4kv-module");
    const panels = module?.querySelectorAll(".air4kv-cnt-item");

    if (!module || !panels?.length) {
      console.warn("缺少 .air4kv-module 或 .air4kv-cnt-item");
      return;
    }

    gsap.to(panels, {
      yPercent: -100 * (panels.length - 1),
      ease: "none",
      scrollTrigger: {
        trigger: module,
        start: "top top",
        end: () => "+=" + (window.innerHeight * (panels.length - 1)),
        scrub: true
      }
    });
  }
}

window.customElements.define("scroll-panel", ScrollPanel);



class IcePointScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = this.querySelector(".ice-point-show");

    if (!triggerEl) {
      console.warn("缺少 .ice-point-show 元素");
      return;
    }

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        start: "top top",
        end: "bottom bottom",
        scrub: true
      }
    });

    tl.to(triggerEl.querySelector(".icepoint__slide-inner2"), {
      clipPath: "inset(0% 0 0 0)",
      duration: 2
    });

    tl.to(triggerEl.querySelectorAll(".icepoint__line-wrapper"), {
      opacity: 1,
      duration: 0.1
    });

    tl.to(triggerEl.querySelectorAll(".icepoint-line"), {
      scaleX: 1
    });

    tl.to(triggerEl.querySelectorAll(".icepoint-line1"), {
      scaleY: 1
    });

    tl.to(triggerEl.querySelectorAll(".icepoint-tle-txt"), {
      opacity: 1,
      duration: 1
    });
  }
}

window.customElements.define("ice-point-scroll", IcePointScroll);


class OutLightScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = this.querySelector(".out-light");
    if (!triggerEl) {
      console.warn("缺少 .out-light 元素");
      return;
    }

    const imagesWrapper = triggerEl.querySelector(".outlight__images-wrapper");
    const contentWrapper = triggerEl.querySelector(".outlight__content-wrapper");

    let t2 = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        start: "top top",
        end: "bottom bottom",
        scrub: true
      }
    });

    if (imagesWrapper) {
      t2.to(imagesWrapper, {
        opacity: 1,
        duration: 1
      });
    }

    if (contentWrapper) {
      t2.to(contentWrapper, {
        opacity: 1,
        duration: 1
      });
    }
  }
}

window.customElements.define("out-light-scroll", OutLightScroll);



class ShrPointScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.error("请先引入 gsap 和 ScrollTrigger 插件");
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const triggerEl = this.querySelector(".shr-point");
    if (!triggerEl) {
      console.warn("缺少 .shr-point 元素");
      return;
    }

    const imagesWrapper = triggerEl.querySelector(".shrpoint__images-wrapper");
    const line = triggerEl.querySelector(".shrpoint-line");
    const contentWrapper = triggerEl.querySelector(".shrpoint__content-wrapper");

    let t3 = gsap.timeline({
      scrollTrigger: {
        trigger: triggerEl,
        start: "top top",
        end: "bottom bottom",
        scrub: true
      }
    });

    if (imagesWrapper) {
      t3.to(imagesWrapper, {
        opacity: 1,
        duration: 1
      });
    }

    if (line) {
      t3.to(line, {
        scaleX: 1,
        duration: 1,
        transformOrigin: "right"
      });
    }

    if (contentWrapper) {
      t3.to(contentWrapper, {
        opacity: 1,
        duration: 1
      });
    }
  }
}

window.customElements.define("shr-point-scroll", ShrPointScroll);



// class ScrollStepPanel extends HTMLElement {
//   constructor() {
//     super();
//     this.observer = null;
//     this.scrollTrigger = null;
//   }

//   connectedCallback() {
//     this.init();
//   }

//   disconnectedCallback() {
//     if (this.scrollTrigger) this.scrollTrigger.kill();
//     if (this.observer) this.observer.disconnect();
//   }

//   init() {
//     if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
//       console.error("请先引入 gsap 和 ScrollTrigger 插件");
//       return;
//     }

//     gsap.registerPlugin(ScrollTrigger);

//     const stepWrap = this.querySelector('.step_cart_wrrap');
//     const stepBox = this.querySelector('.step_cart_box');
//     const stepLists = [...this.querySelectorAll('.step_cart_list')];
//     const eyebrow = this.querySelector('.p-eyebrow');
//     const stepNum = this.querySelector('.step_num');

//     const itemLength = stepLists.length;
//     if (!stepWrap || !stepBox || !eyebrow || !stepNum || itemLength === 0) return;

//     const updateHeight = () => {
//       const listHeight = stepLists[0].clientHeight;
//       stepBox.style.height = `${listHeight * itemLength}px`;
//       // stepWrap.style.height = `${listHeight}px`;
//       // stepWrap.style.setProperty('--device-height', `${listHeight}px`);
//       eyebrow.style.setProperty('--progress', 1 / itemLength);
//     };

//     // 监听 resize 高度变化
//     this.observer = new ResizeObserver(updateHeight);
//     stepLists.forEach((el) => this.observer.observe(el));
//     updateHeight();

//     this.scrollTrigger = ScrollTrigger.create({
//       trigger: stepBox,
//       start: 'top top',
//       end: 'bottom bottom',
//       scrub: false,
//       onUpdate: (self) => {
//         const progress = self.progress;
//         const index = Math.min(
//           Math.floor(progress / (1 / itemLength)),
//           itemLength - 1
//         );

//         eyebrow.style.setProperty('--progress', ((index + 1) / itemLength));
//         stepNum.innerText = String(index + 1).padStart(2, '0');

//         stepLists.forEach((el, i) =>
//           el.classList.toggle('active', i === index)
//         );
//       },
//     });
//   }
// }

// window.customElements.define('scroll-step-panel', ScrollStepPanel);






class WeightWheelAnimation extends HTMLElement {
constructor() {
    super();
  }
  connectedCallback() {
    this.scrollTrigger = this.querySelector('.timeline-box');
     this.videoSection = this.querySelector('.home-hero_cloud-video')
    this.init();
  }
  init() {
    const t1 = gsap.timeline({
      scrollTrigger: {
        trigger: this.scrollTrigger,
        start: "top top",
        end: "bottom bottom",
        scrub: 1
      }
    });

    t1.fromTo( this.videoSection,
      { x: "0", y: "0" },
      { y: "0vw", duration: 1.2, ease: "power3.out" }
    );
  }
}

window.customElements.define('weight-wheel-animation', WeightWheelAnimation);



class ImageComparisonSlider extends HTMLElement {
  constructor(){
    super();
    this.thumberImg = this.querySelectorAll('.effect-thumber-image');
    this.comparisonImg = this.querySelectorAll('.image-comparison');
      this.effectLeft = this.querySelectorAll('.effect-left-bix');
     
    this.init();
  }

  init() {
    this.thumberImg.forEach(thumberImg => {
      thumberImg.addEventListener('click', (e) => {
        this.thumberImg.forEach(thumberImg => {
          thumberImg.classList.remove('active');
        });
        e.currentTarget.classList.add('active');
        this.comparisonImg.forEach(comparisonImg => {
         comparisonImg.classList.remove('active');
        });
        this.comparisonImg[thumberImg.dataset.index].classList.add('active');


         this.effectLeft.forEach(effectLeft => {
         effectLeft.classList.remove('active');
        });
        this.effectLeft[thumberImg.dataset.index].classList.add('active');
        
      });
    });
  }

}

customElements.define('comparison-slide', ImageComparisonSlider);


class ACustomSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.swiper-container');
    if (!swiperContainer) {
      console.error('Swiper container not found');
      return;
    }

    // **设备判断：是否禁用 Swiper**
    const disableOn = this.getAttribute('disable-on'); // 'mobile' 或 'desktop'
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if ((disableOn === 'mobile' && isMobile) || (disableOn === 'desktop' && !isMobile)) {
      console.log(`Swiper disabled on ${disableOn}`);
      return;
    }

    // **Swiper 组件参数**
    const slidesPerView = parseFloat(this.getAttribute('slides-per-view')) || 1.3;
    const spaceBetween = parseFloat(this.getAttribute('space-between')) || 10;
    const loop = this.getAttribute('loop') !== 'false'; // 默认为 true
    const centeredSlides = this.getAttribute('centered-slides') !== 'false'; // 默认为 true
    const paginationEnabled = this.getAttribute('pagination') === 'true'; // 是否启用分页
    const navigationEnabled = this.getAttribute('navigation') === 'true'; // 是否启用导航按钮
    let breakpoints = {};
    try {
      breakpoints = JSON.parse(this.getAttribute('breakpoints') || '{}');
    } catch (error) {
      console.error('Invalid breakpoints format. Expected JSON.');
    }

    // **动态控制 navigation 和 pagination**
    const prevButton = navigationEnabled ? this.querySelector('.swiper-prev') : null;
    const nextButton = navigationEnabled ? this.querySelector('.swiper-next') : null;
    const paginationEl = paginationEnabled ? { el: this.querySelector('.swiper-pagination'), clickable: true } : false;

    this.swiper = new Swiper(swiperContainer, {
      slidesPerView,
      spaceBetween,
      loop,
      centeredSlides,
      navigation: navigationEnabled ? { prevEl: prevButton, nextEl: nextButton } : false,
      pagination: paginationEl,
      breakpoints
    });
  }
}

window.customElements.define('a-custom-swiper', ACustomSwiper);



class modelTab extends HTMLElement {
  constructor() {
    super();
    this.modeTab = this.querySelectorAll('.mode-renewal-tab-item');
    this.modeTextItem = this.querySelectorAll('.mode-renewal-text-item');
    this.rippleWrapper = this.querySelector('.ripple-wrapper');
    this.init();
  }

  init() {
    this.modeTab.forEach(modeTab => {
      modeTab.addEventListener('click', (e) => {
        this.modeTab.forEach(modeTab => {
          modeTab.classList.remove('active');
        });
        e.currentTarget.classList.add('active');
        this.modeTextItem.forEach(modeTextItem => {
         modeTextItem.classList.remove('active');
        });
        this.modeTextItem[modeTab.dataset.index].classList.add('active');
        if(window.innerWidth > 1023){
           this.rippleWrapper.style.setProperty('--ripple-right', `${modeTab.dataset.right}`);
           this.rippleWrapper.style.setProperty('--ripple-top', `${modeTab.dataset.top}`);
        } else {
           this.rippleWrapper.style.setProperty('--ripple-right', `${modeTab.dataset.rightMobile}`);
           this.rippleWrapper.style.setProperty('--ripple-top', `${modeTab.dataset.topMobile}`);
        }
       
      })
    })
  }
}

window.customElements.define('model-tab', modelTab);

